export default __webpack_public_path__ + "static/media/naidi-1.c0216d68.svg";